import { render, staticRenderFns } from "./BizManage.vue?vue&type=template&id=7d2017de&scoped=true&"
import script from "./BizManage.vue?vue&type=script&lang=js&"
export * from "./BizManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2017de",
  null
  
)

export default component.exports